<template>
  <div class="lxn-w100 lxn-h100">
    <div class="TvRemoteControllerSlim2-wrapper-remote lxn-margin-auto lxn-pos-rel lxn-h100">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 335 275" style="enable-background:new 0 0 335 275;vertical-align: middle;" xml:space="preserve" class="TvRemoteControllerSlim1-svg lxn-pos-abs lxn-w100">
      <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#333333;" d="M72.9-0.7h187.7c20.9,0,34.3,5.5,38.1,12.2
        c53.7,97.9,40.7,195.7,0,248.8c-15.1,19.7-247.4,19.5-263.6-0.1c-40.7-48.8-53.7-150.9,0-248.7C38.6,4.9,52-0.7,72.9-0.7L72.9-0.7z"
        />
      <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#1A1A1A;" d="M172.4,92.4l10.9,10.9l-2,2l-8.9-8.9l-8.9,8.9l-2-2L172.4,92.4z
        M172.4,225.2l10.9-10.9l-2-2l-8.9,8.9l-8.9-8.9l-2,2L172.4,225.2z"/>
      <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#1A1A1A;" d="M106.2,158.8l10.9-10.9l2,2l-8.9,8.9l8.9,8.9l-2,2L106.2,158.8z
        M238.8,158.8l-10.9-10.9l-2,2l8.9,8.9l-8.9,8.9l2,2L238.8,158.8z"/>
      <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" d="M167.6,78.3c42.4,0,76.8,34.3,76.8,76.8s-34.5,76.8-76.8,76.8
        s-76.7-34.5-76.7-76.8S125.2,78.3,167.6,78.3L167.6,78.3z M167.6,109.8c25,0,45.3,20.3,45.3,45.3c0,25.1-20.2,45.3-45.3,45.3
        c-25,0-45.3-20.3-45.3-45.3S142.6,109.8,167.6,109.8L167.6,109.8z"/>
      <g>
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#1D71AA;" d="M167.6,116.7c21.2,0,38.3,17.2,38.3,38.4s-17.1,38.4-38.3,38.4
          s-38.3-17.2-38.3-38.4S146.4,116.7,167.6,116.7L167.6,116.7z"/>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_POWER')">
        <g>
          <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#FF6666;" d="M83.8,7.6c18.2,0,32.9,14.7,32.9,32.9s-14.9,33.1-32.9,33.1
            c-18.2,0-32.9-14.7-32.9-33.1C50.9,22.3,65.6,7.6,83.8,7.6L83.8,7.6z"/>
        </g>
        <g>
          <g>
            <path style="fill:#FFFFFF;" d="M77.2,27.8c0.9,0,1.8,0.5,2.2,1.3c0.7,1.2,0.3,2.8-0.9,3.5c-3.2,1.9-5.3,5.4-5.3,9.1
              c0,5.8,4.7,10.6,10.6,10.6s10.6-4.7,10.6-10.6c0-3.7-1.8-7-4.9-8.9c-1.2-0.8-1.6-2.4-0.8-3.6c0.8-1.2,2.4-1.6,3.6-0.8
              c4.6,2.9,7.3,7.9,7.3,13.3c0,8.7-7.1,15.7-15.8,15.7S68,50.3,68,41.6c0-5.6,3-10.8,7.8-13.6C76.3,27.9,76.8,27.8,77.2,27.8z"/>
          </g>
          <g>
            <path style="fill:#FFFFFF;" d="M83.8,23.7c1.4,0,2.6,1.2,2.6,2.6v11.9c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6V26.3
              C81.3,24.9,82.4,23.7,83.8,23.7z"/>
          </g>
        </g>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_SOURCE')">
        <path style="fill:#079950;" d="M265.3,50.5H201c-3.8,0-6.8-3-6.8-6.8V24.1c0-3.8,3-6.8,6.8-6.8h64.3c3.8,0,6.8,3,6.8,6.8v19.6
          C272,47.5,269,50.5,265.3,50.5z"/>
        <g>
          <path style="fill:#FFFFFF;" d="M208.4,37.8c0.7,0.4,1.8,0.8,2.8,0.8c1.6,0,2.6-0.9,2.6-2.1c0-1.2-0.7-1.8-2.3-2.4
            c-2-0.7-3.2-1.8-3.2-3.5c0-1.9,1.6-3.3,4-3.3c1.3,0,2.2,0.3,2.7,0.6l-0.4,1.3c-0.4-0.2-1.2-0.6-2.3-0.6c-1.7,0-2.3,1-2.3,1.8
            c0,1.2,0.8,1.7,2.4,2.4c2.1,0.8,3.1,1.8,3.1,3.6c0,1.9-1.4,3.5-4.3,3.5c-1.2,0-2.5-0.3-3.1-0.8L208.4,37.8z"/>
          <path style="fill:#FFFFFF;" d="M225.6,35.3c0,3.3-2.3,4.7-4.4,4.7c-2.4,0-4.2-1.8-4.2-4.5c0-3,1.9-4.7,4.4-4.7
            C223.9,30.7,225.6,32.6,225.6,35.3z M218.6,35.4c0,1.9,1.1,3.4,2.7,3.4c1.5,0,2.7-1.4,2.7-3.4c0-1.5-0.8-3.4-2.6-3.4
            C219.5,31.9,218.6,33.7,218.6,35.4z"/>
          <path style="fill:#FFFFFF;" d="M235,37.3c0,0.9,0,1.7,0.1,2.4h-1.4l-0.1-1.4l0,0c-0.4,0.7-1.4,1.6-2.9,1.6c-1.4,0-3-0.8-3-3.9
            v-5.2h1.6v4.9c0,1.7,0.5,2.8,2,2.8c1.1,0,1.8-0.8,2.1-1.5c0.1-0.2,0.1-0.5,0.1-0.8v-5.4h1.6L235,37.3L235,37.3z"/>
          <path style="fill:#FFFFFF;" d="M237.7,33.7c0-1,0-1.9-0.1-2.8h1.4l0.1,1.7h0.1c0.4-1.2,1.4-1.9,2.4-1.9c0.2,0,0.3,0,0.5,0v1.6
            c-0.2,0-0.3,0-0.6,0c-1.1,0-1.9,0.9-2.1,2.1c0,0.2-0.1,0.5-0.1,0.8v4.7h-1.6L237.7,33.7L237.7,33.7z"/>
          <path style="fill:#FFFFFF;" d="M249.7,39.4c-0.4,0.2-1.4,0.5-2.5,0.5c-2.7,0-4.4-1.8-4.4-4.5s1.9-4.7,4.7-4.7
            c0.9,0,1.8,0.2,2.2,0.5l-0.4,1.2c-0.4-0.2-1-0.4-1.9-0.4c-2,0-3.1,1.5-3.1,3.3c0,2,1.3,3.3,3.1,3.3c0.9,0,1.5-0.2,2-0.4
            L249.7,39.4z"/>
          <path style="fill:#FFFFFF;" d="M252.4,35.6c0,2.2,1.4,3.1,3,3.1c1.1,0,1.8-0.2,2.4-0.5l0.3,1.2c-0.6,0.2-1.5,0.5-2.9,0.5
            c-2.7,0-4.3-1.8-4.3-4.4s1.6-4.8,4.1-4.8c2.9,0,3.6,2.5,3.6,4.2c0,0.3,0,0.6-0.1,0.8L252.4,35.6L252.4,35.6z M257.1,34.5
            c0-1-0.4-2.6-2.2-2.6c-1.6,0-2.3,1.5-2.5,2.6H257.1z"/>
        </g>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_MUTE')">
        <path style="fill:#666666;" d="M295.8,221.6h-21c-5.5,0-10-4.5-10-10v-21c0-5.5,4.5-10,10-10h21c5.5,0,10,4.5,10,10v21
          C305.8,217.1,301.3,221.6,295.8,221.6z"/>
        <g>
          <g>
            <path style="fill:#FFFFFF;" d="M286.1,204.8l2.7-4l-2.3-3.5c-0.2-0.3-0.4-0.6-0.5-0.9c-0.1-0.2-0.2-0.5-0.2-0.7s0.1-0.4,0.3-0.6
              c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.5,0.6,0.8,1.1l1.8,3l1.9-3c0.2-0.2,0.3-0.5,0.4-0.6
              c0.1-0.1,0.2-0.3,0.3-0.4s0.2-0.2,0.4-0.3c0.2-0.1,0.3-0.1,0.4-0.1c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.3,0.4,0.3,0.7
              c0,0.4-0.2,0.9-0.6,1.5l-2.4,3.6l2.6,4c0.2,0.4,0.4,0.6,0.5,0.9c0.1,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.1,0.5s-0.2,0.3-0.4,0.4
              c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.3-0.4-0.6-0.8l-2.1-3.4l-2.3,3.5
              c-0.2,0.3-0.3,0.5-0.4,0.6c-0.1,0.1-0.2,0.2-0.3,0.3s-0.2,0.2-0.4,0.2c-0.2,0-0.3,0.1-0.5,0.1c-0.3,0-0.6-0.1-0.7-0.3
              c-0.2-0.2-0.3-0.4-0.3-0.8C285.5,205.9,285.7,205.4,286.1,204.8z"/>
          </g>
          <rect x="275.8" y="197.6" style="fill:#FFFFFF;" width="2.6" height="7"/>
          <polygon style="fill:#FFFFFF;" points="284.8,207.7 278.3,204.6 278.3,197.6 284.8,194.5 		"/>
        </g>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_MENU')">
        <path style="fill:#666666;" d="M55.1,130.6h-21c-5.5,0-10-4.5-10-10v-21c0-5.5,4.5-10,10-10h21c5.5,0,10,4.5,10,10v21
          C65.1,126.1,60.7,130.6,55.1,130.6z"/>
        <path style="fill:#FFFFFF;" d="M56.8,112.2H33c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h23.8c0.6,0,1.1,0.5,1.1,1.1
          S57.4,112.2,56.8,112.2z"/>
        <path style="fill:#FFFFFF;" d="M56.8,103.9H33c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h23.8c0.6,0,1.1,0.5,1.1,1.1
          S57.4,103.9,56.8,103.9z"/>
        <path style="fill:#FFFFFF;" d="M56.8,120.5H33c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h23.8c0.6,0,1.1,0.5,1.1,1.1
          S57.4,120.5,56.8,120.5z"/>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_BACK')">
        <path style="fill:#666666;" d="M303.1,128.4h-21c-5.5,0-10-4.5-10-10v-21c0-5.5,4.5-10,10-10h21c5.5,0,10,4.5,10,10v21
          C313.1,123.9,308.6,128.4,303.1,128.4z"/>
        <path style="fill:#FFFFFF;" d="M300,101.5h-16.7l3.4-3.8c0.5-0.5,0.5-1.4,0-1.9s-1.3-0.5-1.7,0l-5.5,6.1c-0.5,0.5-0.5,1.4,0,1.9
          l5.5,6.1c0.2,0.3,0.6,0.4,0.9,0.4s0.6-0.1,0.9-0.4c0.5-0.5,0.5-1.4,0-1.9l-3.4-3.8h16.7c2.7,0,4.8,2.4,4.8,5.3s-2.2,5.3-4.8,5.3
          h-10.2c-0.7,0-1.2,0.6-1.2,1.4s0.6,1.4,1.2,1.4h10.2c4,0,7.3-3.6,7.3-8C307.3,105.1,304,101.5,300,101.5z"/>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_OK')">
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#1D71AA;" d="M168,124c16.3,0,29.5,13.3,29.5,29.6
          c0,16.3-13.2,29.6-29.5,29.6s-29.5-13.2-29.5-29.6C138.5,137.3,151.7,124,168,124L168,124z"/>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_OK')">
        <path style="fill:#FFFFFF;" d="M167.8,155.5c0,4.2-2.6,6.5-5.7,6.5c-3.2,0-5.5-2.5-5.5-6.2c0-3.9,2.4-6.4,5.7-6.4
          C165.6,149.3,167.8,151.9,167.8,155.5z M158.2,155.7c0,2.6,1.4,5,3.9,5s3.9-2.3,3.9-5.1c0-2.4-1.3-5-3.9-5
          C159.6,150.6,158.2,153,158.2,155.7z"/>
        <path style="fill:#FFFFFF;" d="M169.8,149.5h1.6v5.9h0.1c0.3-0.5,0.7-0.9,1-1.3l3.8-4.6h2l-4.4,5.2l4.8,7.1h-1.9l-4-6l-1.2,1.4v4.7
          H170L169.8,149.5L169.8,149.5z"/>
      </g>
      <rect class="lxn-cursor-pointer" @click="buttonClicked('KEY_RIGHT')" x="212.9" y="137.4" style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" width="29.1" height="32.4"/>
      <polygon class="lxn-cursor-pointer" @click="buttonClicked('KEY_RIGHT')" style="fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;" points="232.9,153.6 222.1,142.8 220.1,144.7 229,153.6 
        220.1,162.5 222.1,164.5 "/>
      <rect class="lxn-cursor-pointer" @click="buttonClicked('KEY_UP')" x="154" y="80.4" style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" width="29.1" height="29.4"/>
      <rect class="lxn-cursor-pointer" @click="buttonClicked('KEY_LEFT')" x="93" y="137.4" style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" width="29.1" height="32.4"/>
      <rect class="lxn-cursor-pointer" @click="buttonClicked('KEY_DOWN')" x="156.3" y="200.9" style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" width="29.1" height="29.1"/>
      <polygon class="lxn-cursor-pointer" @click="buttonClicked('KEY_UP')" style="fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;" points="168.5,91.2 179.4,102.1 177.4,104.1 168.5,95.2 
        159.6,104.1 157.6,102.1 "/>
      <polygon class="lxn-cursor-pointer" @click="buttonClicked('KEY_LEFT')" style="fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;" points="101.1,153.6 111.9,142.8 113.9,144.7 105,153.6 
        113.9,162.5 111.9,164.5 "/>
      <polygon class="lxn-cursor-pointer" @click="buttonClicked('KEY_DOWN')" style="fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;" points="170.5,221.1 181.4,210.2 179.4,208.2 170.5,217.1 
        161.6,208.2 159.6,210.2 "/>
      <g class="lxn-cursor-pointer" @click="openRemote()">
        <path style="fill:#666666;" d="M61.4,218.3h-21c-5.5,0-10-4.5-10-10v-21c0-5.5,4.5-10,10-10h21c5.5,0,10,4.5,10,10v21
          C71.4,213.8,67,218.3,61.4,218.3z"/>
        <path style="fill:#FFFFFF;" d="M48.1,194.8l1.3,0c0.2-0.6,0.7-1,1.3-1.3v-1.3C49.4,192.6,48.4,193.5,48.1,194.8L48.1,194.8z
          M51.4,195c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h0c0.3,0,0.6-0.3,0.6-0.6S51.8,195,51.4,195z"/>
        <path style="fill:#FFFFFF;" d="M49.4,196.4l-1.3,0c0.3,1.2,1.3,2.2,2.5,2.5v-1.3C50.1,197.4,49.6,197,49.4,196.4L49.4,196.4z
          M52.3,192.3v1.3c0.6,0.2,1,0.7,1.3,1.3h1.3C54.5,193.5,53.5,192.6,52.3,192.3z M62.1,191.8l-6.8-6.8c-0.6-0.6-1.3-0.9-2.2-0.9
          s-1.6,0.3-2.2,0.9l-13.4,13.4c-3.1,3.1-3.1,8.1,0,11.2c1.5,1.5,3.5,2.3,5.6,2.3s4.1-0.8,5.6-2.3l13.4-13.4
          C63.3,194.9,63.3,193,62.1,191.8L62.1,191.8z M53.5,188.4c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6
          c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6S53.4,188.5,53.5,188.4
          L53.5,188.4z M45.9,200c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6
          c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6C45.6,200.4,45.7,200.2,45.9,200L45.9,200z M43.2,197.4
          c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6c0,0.4-0.4,0.8-0.8,0.8c-0.2,0-0.4-0.1-0.6-0.2
          c-0.2-0.2-0.2-0.4-0.2-0.6S43,197.5,43.2,197.4L43.2,197.4z M41.2,199.4c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2
          c0.2,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6
          C41,199.7,41,199.5,41.2,199.4z M39,201.9c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2
          c0.2,0.2,0.2,0.4,0.2,0.6c0,0.4-0.4,0.8-0.8,0.8c-0.2,0-0.4-0.1-0.6-0.2C39,202.4,39,202.2,39,201.9L39,201.9z M41,207.2
          c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2
          c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6C41.3,206.8,41.2,207,41,207.2L41,207.2z M43,205.2c-0.2,0.2-0.4,0.2-0.6,0.2
          c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2
          c0.2,0.2,0.2,0.4,0.2,0.6C43.3,204.8,43.2,205,43,205.2L43,205.2z M43.6,202.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2
          c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6c0,0.4-0.4,0.8-0.8,0.8c-0.2,0-0.4-0.1-0.6-0.2C43.7,203,43.6,202.8,43.6,202.6
          L43.6,202.6z M45.7,207.9c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6
          c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6C45.9,207.5,45.8,207.7,45.7,207.9L45.7,207.9z
          M47.7,205.9c-0.2,0.2-0.4,0.2-0.6,0.2s-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2
          c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6C47.9,205.5,47.8,205.7,47.7,205.9L47.7,205.9z M49.7,203.8
          c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.3-0.3-0.3-0.8,0-1.2c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2
          c0.2,0.2,0.2,0.4,0.2,0.6C49.9,203.5,49.8,203.7,49.7,203.8L49.7,203.8z M51.4,200.7c-2.8,0-5.1-2.3-5.1-5.1c0-2.8,2.3-5.1,5.1-5.1
          c2.8,0,5.1,2.3,5.1,5.1C56.5,198.4,54.2,200.7,51.4,200.7z M58.7,193.5c-0.3,0.3-0.8,0.3-1.2,0c-0.2-0.2-0.2-0.4-0.2-0.6
          c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6C58.9,193.1,58.8,193.4,58.7,193.5
          L58.7,193.5z M52.3,197.7v1.3c1.2-0.3,2.2-1.3,2.5-2.5h-1.3C53.3,197,52.8,197.4,52.3,197.7L52.3,197.7z"/>
      </g>
      </svg>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'

export default {
  name: 'TvRemoteControllerSlim2',
  props: {
    nodeUUID: Number,
    outputIndex: Number,
    sendCommand: Boolean,
  },
  data: function() {
    return {
      node: this.$store.getters.getNodeByUUID(this.nodeUUID),
      targetCommandIndex: -1,
      commandSetTimeoutHandle: -1,
      debounceDelay: 0,
    }
  },
  components: {
    ButtonIcon
  },
  mounted: function () {
  },
  watch: {
    nodeUUID: function (newVal) {
      this.node =this.$store.getters.getNodeByUUID(newVal);
    },
    targetCommandIndex: function (newVal) {
      if(newVal == -1){
        return;
      }
      if(this.sendCommand){
        clearTimeout(this.commandSetTimeoutHandle);
        this.commandSetTimeoutHandle = setTimeout(function () {
          this.$store.commit('setAppBusy', true);
          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          this.$store.dispatch('setNodesParameters', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.node.uuid,
            bodyContent: {
              nodeActions: [
                {
                  nodeUUID: this.node.uuid,
                  actions: [
                    {
                      parameterId: NODE7.IR.PARAMETER_ID,
                      valueOfChange: messagingHook.utility.arrayTo128(this.irDevice.commands[newVal].command),
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: 0
                    }
                  ]
                },
              ]
            }
          })
          .then( () => {
            console.log("Done");
            this.$store.commit('setAppBusy', false);
          })
          .catch( response => {
            if(response.rejectCode == 1){
              this.$router.push('/SettingsNodeError');
            }else if(response.rejectCode == 2){
              this.$router.push('/SettingsHubError');
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
            this.$store.commit('setAppBusy', false);
          })
          .finally( () => {
            this.targetCommandIndex = -1;
          })
        }.bind(this), this.debounceDelay);
      }
    },
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    output: function () {
      return this.node.outputs[this.outputIndex];
    },
    irDevice: function () {
      var irDevice = NODE7.devices[this.output.settings.deviceType].brands[this.output.settings.brand].devices[this.output.settings.model];
      return irDevice;
    },
  },
  methods: {
    buttonClicked: function (button) {
      var commandIndex = this.irDevice.commands.findIndex( command => command.function == button);
      if(commandIndex != -1){
        this.targetCommandIndex = commandIndex;
      }
    },
    openRemote: function () {
      this.$router.push('/showIrRemote/' + this.nodeUUID + '/' + this.outputIndex);
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .TvRemoteControllerSlim2-wrapper-remote {
    width: 90%;
  }
  .TvRemoteControllerSlim1-svg {
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
</style>
